import React from 'react';
import PropTypes from 'prop-types';
import Space from '@src/components/Space';
import SwipeSlider from '@src/components/SwipeSlider';

import css from './style.module.scss';

const Recent = (props) => {
	const { title, places, onClickLike, sliderTrackMix, sliderWrapMix } = props;

	return (
		<div className={css.block}>
			{places.length > 0 && (
				<SwipeSlider
					title={title}
					slideMix={css.slide}
					headMix={css.head}
					isInnerArrows={false}
					trackMix={sliderTrackMix}
					wrapMix={sliderWrapMix}
					swipeQtty="auto"
				>
					{places.map((place) => (
						<Space
							key={place.id}
							state="medium"
							{...place}
							mediaQueries={null}
							imgWidth={240}
							imgHeight={160}
							onClickHeart={onClickLike}
						/>
					))}
				</SwipeSlider>
			)}
		</div>
	);
};

Recent.propTypes = {
	/**
	 * Заголовок блока.
	 */
	title: PropTypes.string,
	/**
	 * Массив объектов, описывающих карточки заведений.
	 */
	places: PropTypes.arrayOf(PropTypes.shape({ ...Space.type.propTypes })),
	/**
	 * Обработчик клика по иконке сердца в карточках.
	 */
	onClickLike: PropTypes.func,
	sliderTrackMix: SwipeSlider.type.propTypes.trackMix,
	sliderWrapMix: SwipeSlider.type.propTypes.wrapMix,
};

Recent.defaultProps = {
	title: t('Просмотренные'),
	places: [],
	onClickLike: undefined,
	sliderTrackMix: undefined,
	sliderWrapMix: undefined,
};

export default Recent;
